<template>
  <div class="width-expand">
    <base-form
      ref="searchForm"
      v-bind="$attrs"
      v-model="searchModel"
      method="get"
      :action="searchUrl"
      class="width-expand"
      :error-display-position="'absolute'"
      :field-wrapper-margin="false"
      :config="searchFormConfig"
      @form:submitProcessStart="handleSearchStart"
      @submit="handleSearchStart"
      @form:submitEnd="handleSearchSubmitComplete"></base-form>

    <drawer
      v-model="isShowingResultUi"
      location="bottom"
      class="test-1"
      style="max-height: 90lvh">
      <!-- results container - has results -->
      <div
        v-if="!isSearching && hasResults"
        class="animate__fadeIn animate--fast results container container-m min-height-200">
        <h3 class="h2 results-title text-center">
          {{
            translateUcFirst("justopp.search.resultCountTitle", { count: resultCount })
          }}
        </h3>
        <div class="results max-width-800 margin-auto-horizontal flex-wrap gap-l m:flex-start flex-center flex-stretch">
          <component v-for="item in results"
                     @list-item:request-close="close"
                     :is="getResultComponent(item)"
                     :item="item">
            {{getResultComponent(item)}}
          </component>
          <!--
          <div class="search-result" style="">
            <div class="media" style="">
              <badge class="m:hidden mobile-badge" theme="inverse" size="l" icon="bag"
                >שירות</badge
              >

              <img
                class=""
                src="https://fileserver.saffron-technologies.com/api/files/90849209-2b40-4140-9317-5ece9583ee25/6cd41e20-14da-418b-90d2-c10f3263a693.jpeg"
                alt="" />
            </div>
            <div
              class="content padding-s-vertical padding-l-inline-end width-expand flex-between flex-middle gap-xl padding-m-vertical">
              <div class="main-result-content overflow-auto gap-s width-expand">
                <span class="result-title h4 margin-s-bottom flex-middle gap-m">
                  <badge class="m:visible" theme="inverse" icon="bag">שירות</badge>
                  <span>בידור מגבות</span>
                </span>

                <div class="result-description margin-m-bottom">
                  <p>בידור למגבות מטבח ואף למגבות אמבט, לרבות קריוקי ועישון...</p>
                </div>
                <hr class="width-expand" />
                <div class="tags-container flex flex-wrap gap-s">
                  <badge theme="gray-5">מגבות</badge>
                  <badge theme="gray-5">בידור</badge>
                  <badge theme="gray-5">מתאים לילדים</badge>
                  <badge theme="danger">מבוגרים בלבד</badge>
                </div>
              </div>
              <div class="result-cta">
                <form-button theme="alt">לפרופיל האמן</form-button>
                <form-button theme="lead">התחל הזמנה</form-button>
              </div>
            </div>
          </div>
          -->
        </div>
        <div class="flex-column flex-middle flex-center margin-2xl-top">
          <h3 class="h2 c-lead results-title text-center margin-m-bottom">
            {{ translateUcFirst("justopp.search.newSearchExplain") }}
          </h3>
          <form-input
            v-bind="searchFormConfig.fields.q"
            v-model="searchModel.q"
            @keyup.enter="submitMainForm()"></form-input>
        </div>
      </div>

      <!-- results container - no results -->
      <div
        v-if="!isSearching && !hasResults"
        class="animate__fadeIn animate--fast results container container-m min-height-200">
        <div class="flex-column flex-middle flex-center">
          <h3 class="h2 c-lead results-title text-center margin-s-bottom">
            {{ translateUcFirst("justopp.search.noResultsTitle") }}
          </h3>
          <p
            class="text-xl text-center margin-auto-horizontal margin-top-remove margin-2xl-bottom">
            {{ translate("justopp.search.noResultsExplain") }}
          </p>
          <form-input
            v-bind="searchFormConfig.fields.q"
            v-model="searchModel.q"
            @keyup.enter="submitMainForm()"></form-input>
        </div>
      </div>
      <!-- loading UI -->
      <div
        v-if="isSearching"
        class="animate__fadeIn animate--fast loading flex flex-middle flex-center min-height-300 width-expand">
        <spinner size="4" text="justopp.search.searching"></spinner>
      </div>
    </drawer>
  </div>
</template>

<script>
import GenericListItem from "@/client/applications/justopp/components/items/generic/ListItem.vue";
import VendorListItem from "@/client/applications/justopp/components/items/vendor/ListItem.vue";
import ProductListItem from "@/client/applications/justopp/components/items/product/ListItem.vue";
let appName = process.env.VUE_APP_APPLICATION_NAME;
export default {
  components: {
    GenericListItem, VendorListItem,ProductListItem,
  },
  props: {
    inputSize: {
      type: String,
      default: "m",
    },
    inputProps: {
      type: Object,
      default: {}
    },
    searchUrl: {
      type: String,
      default: `${appName}/search`
    }
  },
  data: function () {
    return {
      isShowingResultUi: false,
      isSearching: false,
      searchModel: {
        q: "",
      },
      searchFormConfig: {
        fields: {
          q: {
            name: "q",
            label: false,
            placeholder: "justopp.search.searchPlaceholder",
           // icon: "search",
            type: "text",
            size: this.inputSize,
            ...this.inputProps,
          },
        },
        buttons: {},
        formHandling: {},
      },
      results: [],
      resultCount: 0,
    };
  },
  computed: {
    hasResults() {
      return Array.isArray(this.results) && this.results.length > 0;
    },
    finalResults() {
      return this.results;
    },
    visibleResults() {
      return this.results;
    }
  },
  methods: {
    resetSearchModel() {
      this.searchModel.q = "";
    },
    handleSearchStart() {
      this.goToResultsLoadingState();
    },
    goToResultsLoadingState() {
      this.results = [];
      this.resultCount = 0;
      this.isSearching = true;
      this.isShowingResultUi = true;
    },
    submitMainForm() {
      this.goToResultsLoadingState();
      this.$refs.searchForm.submitAsync();
    },
    handleSearchSubmitComplete({ component, data, isError, result }) {
      this.isSearching = false;

      if (isError) {
        try {
          // this form is compact, errors are a problem with the alert component
          u.inTwoTicks(() => {
            this.$refs.searchForm.hideSubmitError();
          });
        } catch (e) {
          console.log(e);
        }
        this.$s.ui.notification("justopp.search.exceptionNotification", "error");
        return false;
      }

      // success

      this.results = result.data.items;
      this.resultCount = result.data.count;
      this.isShowingResultUi = true;
    },
    startSearch(term) {
      this.searchModel.q = term;
      this.submitMainForm();
    },
    getResultComponent(res) {
      return utilities.lcFirst(res.type) + '-list-item';
    },
    close() {
      this.results = [];
      this.resultCount = 0;
      this.isSearching = false;
      this.isShowingResultUi = false;
    }
  },
  mounted() {
   // this.startSearch('test');
  },
};
</script>

<style scoped lang="scss">
.search-result {
  border: 1px solid var(--c-gray-2);
  background: var(--c-bg-4);
  border-radius: var(--border-radius-s);
  display: flex;
  gap: var(--margin-l);
  height: 120px;
  flex: 100%;
  position: relative;

  @media (max-width: 767px) {
    flex-direction: column;
    flex: 0 0 auto;
    width: 250px;
    height: auto;
    gap: var(--margin-m);
  }

  .media {
    min-height: 100%;
    flex: 0 0 120px;
    border-radius: var(--border-radius-s);

    img {
      object-fit: cover;
      max-height: 100%;
      max-width: 100%;
      height: 100%;
      width: 100%;
      border-radius: var(--border-radius-s);
    }

    @media (max-width: 767px) {
      height: 120px;
      flex: 0 0 120px;
      width: 100%;
      min-height: 120px;
    }
  }

  .mobile-badge {
    position: absolute;
    top: var(--margin-m);
    inset-inline-start: var(--margin-m);
    border-radius: var(--border-radius-s);
  }

  .content {
    padding-block: var(--margin-m);
    padding-inline-end: var(--margin-l);
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: var(--margin-xl);
    align-items: center;

    @media (max-width: 767px) {
      padding-top: 0;
      padding: var(--margin-m);
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      flex: 100%;
    }
  }

  .result-title {
    @media (max-width: 767px) {
      justify-content: center;
      text-align: center;
    }
  }

  .result-description {
    @media (max-width: 767px) {
      text-align: center;
    }
  }

  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: var(--margin-s);

    @media (max-width: 767px) {
      justify-content: center;
    }
  }

  .result-description {
    max-width: 100%;

    p {
      text-overflow: ellipsis;
      max-height: 1em;
      overflow: hidden;
      white-space: nowrap;
      max-width: 800px;

      @media (max-width: 1024px) {
        max-width: 300px;
      }
    }
  }

  .result-cta {
    display: flex;
    flex-direction: column;
    gap: var(--margin-m);
    padding-block: var(--margin-m);

    @media (max-width: 767px) {
      width: 100%;

      .button {
        width: 100%;
      }
    }
  }
}
</style>
